import { useContext } from "react";
import { AuthContext } from "../context/UserDataProvider";

const useAuth = () => {
  const auth = useContext(AuthContext);
  return auth;
};

export default useAuth;
